import { useAtlas } from "@/context/AtlasContext";
import { ShieldAlert } from "lucide-react";

export default function AccessDenied({ slug, noWorkspace }) {
  const { logout, tenants } = useAtlas();
  const mine = (tenants || []).filter((t) => !t.support);
  return (
    <div className="h-screen flex items-center justify-center p-6" style={{ background: "var(--paper)" }} data-testid="access-denied-page">
      <div className="max-w-md w-full text-center">
        <div className="w-14 h-14 rounded-2xl bg-red-50 flex items-center justify-center mx-auto mb-5"><ShieldAlert className="w-7 h-7 text-red-500" /></div>
        <h1 className="font-heading text-2xl font-semibold text-slate-900">
          {noWorkspace ? "No workspace available" : "You don't have access to this company"}
        </h1>
        <p className="text-sm text-slate-500 mt-2">
          {noWorkspace
            ? "Your account is not a member of any workspace yet. Ask an administrator to invite you."
            : "This company workspace is not one you can open. Switch to a workspace you belong to, or ask an administrator for access."}
        </p>
        {mine.length > 0 && (
          <div className="mt-6 flex flex-col gap-2" data-testid="access-denied-workspaces">
            {mine.map((t) => (
              <a key={t.id} href={`/t/${t.slug}/home`} className="block w-full px-4 py-2.5 rounded-xl border text-sm font-medium text-slate-700 hover:bg-slate-50" style={{ borderColor: "var(--line)" }} data-testid={`access-goto-${t.id}`}>
                Go to {t.name}
              </a>
            ))}
          </div>
        )}
        <button onClick={logout} className="mt-6 text-sm text-slate-500 underline" data-testid="access-denied-signout">Sign out</button>
      </div>
    </div>);
}
